import { render, staticRenderFns } from "./leaderBoardWinnerList.vue?vue&type=template&id=ea5c90b4&scoped=true&"
import script from "./leaderBoardWinnerList.vue?vue&type=script&lang=js&"
export * from "./leaderBoardWinnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5c90b4",
  null
  
)

export default component.exports